import React from 'react';
// Import images


const CtaTwo = () => {
  return (
    <>
    {/*CTA One Start*/}
    <section className="cta-one">
    <div className="container">
      <div className="cta-one__inner">
        <h3 className="cta-one__title">
          <br />Abonnez-vous  à notre newsletter
        </h3>
        <form
          className="cta-one__form mc-form"
          data-url="MC_FORM_URL"
          noValidate
        >
          <div className="cta-one__form-input-box">
            <input
              type="email"
              placeholder="Entrez votre adresse e-mail"
              name="EMAIL"
            />
            <button type="submit" className="cta-one__btn">
              <span className="icon-paper-plan"></span>
            </button>
          </div>
        </form>
      </div>
    </div>
    </section>
    {/*CTA One End*/}
    </>
  );
};

export default CtaTwo;
